import { render, staticRenderFns } from "./CertificateTableNew.vue?vue&type=template&id=13244168&scoped=true"
import script from "./CertificateTableNew.vue?vue&type=script&lang=js"
export * from "./CertificateTableNew.vue?vue&type=script&lang=js"
import style0 from "./CertificateTableNew.vue?vue&type=style&index=0&id=13244168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13244168",
  null
  
)

export default component.exports